module.exports = ".custom-dialog-actions {\n  float: right;\n  margin-top: 1.5em; }\n\n.custom-dialog {\n  overflow: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/custom-dialog/custom-dialog.component.scss
// module id = ./src/app/widgets/custom-dialog/custom-dialog.component.scss
// module chunks = main